import moment, { months } from 'moment';

export function buildActivityYearlyDetailsItems(activity, key, previousDetails, parameters, date_ = undefined) {
    const date = date_ || parameters.start
    // build or rebuild data structure every time the budget is loaded or a yearly total is modified
    if (key+1 > activity.years.length) {
        // years not used
        return [];
    }
    const yearlyDetailsItems = buildActivityYearlyDetailsItemsFromScratch(key, activity, parameters, date);
    if (!previousDetails || previousDetails.length === 0) {
        // first building at the creation of the budget, TO PUT IN CP ?
        return yearlyDetailsItems;
    }
    let oneEditedMonthIndex = -1; // counter keeping track of an edited month, used to update unmodified columns at the end (trick)
    for (let monthIndex = 0; monthIndex < previousDetails[0].months.length; monthIndex++) {
        // we could have taken yearlyDetailsItems to reference the indexes instead of previousDetails
        if (previousDetails[0].months[monthIndex].edited) {
            if (oneEditedMonthIndex < 0) {
                oneEditedMonthIndex = monthIndex;
            };
            if (previousDetails[0].months[monthIndex].manuallyModified) {
                // value to keep is the amount, computing the new saisonnalities and margins, but not updating the other columns yet to reduce computation time
                yearlyDetailsItems[0].uneditedCount -= 1;
                yearlyDetailsItems[0].months[monthIndex].edited = true;
                yearlyDetailsItems[0].months[monthIndex].manuallyModified = true;
                yearlyDetailsItems[0].months[monthIndex].amount = previousDetails[0].months[monthIndex].amount;
                yearlyDetailsItems[1].uneditedCount -= 1;
                yearlyDetailsItems[1].months[monthIndex].edited = true;
                yearlyDetailsItems[1].months[monthIndex].amount = (100 * yearlyDetailsItems[0].months[monthIndex].amount / yearlyDetailsItems[0].total).toFixed(2);
                yearlyDetailsItems[2].uneditedCount -= 1;
                yearlyDetailsItems[2].months[monthIndex].edited = true;
                yearlyDetailsItems[2].months[monthIndex].amount = (yearlyDetailsItems[0].months[monthIndex].amount * activity.marginRate / 100).toFixed(2);
            }
            else if (previousDetails[1].months[monthIndex].manuallyModified) {
                // value to keep is the saisonnality, computing the new amounts and margins, but not updating the other columns yet to reduce computation time
                yearlyDetailsItems[1].uneditedCount -= 1;
                yearlyDetailsItems[1].months[monthIndex].edited = true;
                yearlyDetailsItems[1].months[monthIndex].manuallyModified = true;
                yearlyDetailsItems[1].months[monthIndex].amount = previousDetails[1].months[monthIndex].amount;
                yearlyDetailsItems[0].uneditedCount -= 1;
                yearlyDetailsItems[0].months[monthIndex].edited = true;
                yearlyDetailsItems[0].months[monthIndex].amount = (yearlyDetailsItems[0].total * yearlyDetailsItems[1].months[monthIndex].amount / 100).toFixed(0);
                yearlyDetailsItems[2].uneditedCount -= 1;
                yearlyDetailsItems[2].months[monthIndex].edited = true;
                yearlyDetailsItems[2].months[monthIndex].amount = (yearlyDetailsItems[0].months[monthIndex].amount * activity.marginRate / 100).toFixed(2);
            }
            else if(previousDetails[2].months[monthIndex].manuallyModified) {
                // value to keep is the margin, computing the new amounts and saisonnality, but not updating the other columns yet to reduce computation time
                yearlyDetailsItems[2].uneditedCount -= 1;
                yearlyDetailsItems[2].months[monthIndex].edited = true;
                yearlyDetailsItems[2].months[monthIndex].manuallyModified = true;
                yearlyDetailsItems[2].months[monthIndex].amount = previousDetails[2].months[monthIndex].amount;
                yearlyDetailsItems[0].uneditedCount -= 1;
                yearlyDetailsItems[0].months[monthIndex].edited = true;
                yearlyDetailsItems[0].months[monthIndex].amount = (100 * yearlyDetailsItems[2].months[monthIndex].amount / activity.marginRate).toFixed(0);
                yearlyDetailsItems[1].uneditedCount -= 1;
                yearlyDetailsItems[1].months[monthIndex].edited = true;
                yearlyDetailsItems[1].months[monthIndex].amount = (100 * yearlyDetailsItems[0].months[monthIndex].amount / yearlyDetailsItems[0].total).toFixed(2);
            }
        }
    }
    if (oneEditedMonthIndex >= 0) {
        recomputeWhenChange(activity, yearlyDetailsItems, 0, oneEditedMonthIndex); // updating the unedited columns
    }
    return yearlyDetailsItems;
}

function buildActivityYearlyDetailsItemsFromScratch(key, activity, parameters, date) {
    // construction of the details at the creation of a budget, if there is no previous values
    const yearlyDetailsItems = [];
    const monthList = getOrderedMonthsPeriods(parameters, date)[key];
    const monthsNumber = monthList.length;
    const totalAmount = activity.years[key].amount;
    const splittedAmount = totalAmount / monthsNumber;
    const months = [];
    for (let monthIndex = 0; monthIndex < monthsNumber; monthIndex++) {
        const month = {
            amount: splittedAmount.toFixed(0),
            date: monthList[monthIndex],
            edited: false,
            manuallyModified: false
        };
        months.push(month)
    }
    const soldPrestations = {
        title: "Prestations vendues",
        total: totalAmount,
        months: months,
        uneditedCount: months.length,
        editable: true
    };
    yearlyDetailsItems.push(soldPrestations);
    const monthsSaisonnality = []
    for (let monthIndex = 0; monthIndex < monthsNumber; monthIndex++) {
        const amount = totalAmount === 0 ? 0 : months[monthIndex].amount / totalAmount * 100
        const month = {
            amount: amount.toFixed(2),
            date: monthList[monthIndex],
            edited: false,
            manuallyModified: false
        };
        monthsSaisonnality.push(month);
    }
    const saisonnality = {
        title: "Saisonnalité",
        total: 100,
        months: monthsSaisonnality,
        uneditedCount: months.length,
        editable: true

    };
    yearlyDetailsItems.push(saisonnality);
    const monthsMargins = [];
    for (let monthIndex = 0; monthIndex < monthsNumber; monthIndex++) {
        const amount = months[monthIndex].amount === 0 ? 0 : months[monthIndex].amount * activity.marginRate / 100
        const month = {
            amount: amount,
            date: monthList[monthIndex],
            edited: false,
            manuallyModified: false
        }
        monthsMargins.push(month)
    }
    const margins = {
        title: "Marges sur production",
        total: totalAmount * activity.marginRate/100,
        months: monthsMargins,
        uneditedCount: months.length,
        editable: true
    };
    yearlyDetailsItems.push(margins);
    return yearlyDetailsItems;
}

export function getOrderedMonthsFirstPeriod(parameters, date) {
    const orderedMonthsFirstPeriod = [];
    let currentMonth = moment(date).format("MMMM YYYY");
    orderedMonthsFirstPeriod.unshift(currentMonth);
    for (let month = 1; month < parameters.firstPeriodMonthsNumber; month++) {
        currentMonth = moment(currentMonth, "MMMM YYYY").add(1, 'months').format("MMMM YYYY");
        orderedMonthsFirstPeriod.push(currentMonth);
    }
    return orderedMonthsFirstPeriod;
}

export function getOrderedMonthsPeriods(parameters, date) {
    // creation of the month list of each accountingPeriod
    const orderedMonthsPeriods = [];
    orderedMonthsPeriods.unshift(getOrderedMonthsFirstPeriod(parameters, date)); // creation of the first period is different because it may contains more than 12 months
    for (let year = 1; year < parameters.periodsNumber; year++) {
        const orderedMonthsCurrentPeriod = [];
        const previousYearLastMonthIndex = year === 1 ? parameters.firstPeriodMonthsNumber-1 : 11;
        let currentMonth = moment(orderedMonthsPeriods[year-1][previousYearLastMonthIndex], "MMMM YYYY").add(1, 'months').format("MMMM YYYY"); // get the first month of the current period
        orderedMonthsCurrentPeriod.unshift(currentMonth);
        for (let month = 1; month < parameters.firstPeriodMonthsNumber; month++) {
            currentMonth = moment(currentMonth, "MMMM YYYY").add(1, 'months').format("MMMM YYYY");
            orderedMonthsCurrentPeriod.push(currentMonth);
        }
        orderedMonthsPeriods.push(orderedMonthsCurrentPeriod);
    }
    return orderedMonthsPeriods;
}

function recomputeWhenChange(activity, yearlyDetails, detailsLineIndex, amountChangedIndex) {

    // update the line of the current change while modifying the unedited amounts
    const details = yearlyDetails;
    const detailsLine = details[detailsLineIndex];
    const amountToKeep = detailsLine.months[amountChangedIndex].amount;
    if (!detailsLine.months[amountChangedIndex].edited) {
        detailsLine.uneditedCount -= 1;
        detailsLine.months[amountChangedIndex].edited = true;
        detailsLine.months[amountChangedIndex].manuallyModified = true;
    }
    const subTotal = computeSubTotal(detailsLine); // subTotal to divise between the unedited left months
    for (const month of detailsLine.months) {
        if (!month.edited) {
            month.amount = (subTotal / detailsLine.uneditedCount).toFixed(2);
        }
    }
    const amountsLine = details[0];
    const percentagesLine = details[1];
    const marginsLine = details[2];
    if (detailsLine.title === "Saisonnalité") {
        recomputeAmountsWhenSaisonnalityChange(amountsLine, amountChangedIndex, amountToKeep);
        // recomputeMargins cannot be launched until amountsLine is up to date
        if (activity) {
            recomputeMargins(activity, marginsLine, amountChangedIndex, amountsLine.months[amountChangedIndex].amount); // it uses the amount attribute of the modified column instead of the percentage
        }
    }
    else if (detailsLine.title === "Prestations vendues") {
        recomputeSaisonnalityWhenAmountsChange(amountsLine, percentagesLine, amountChangedIndex, amountToKeep);
        if (activity) {
            recomputeMargins(activity, marginsLine, amountChangedIndex, amountToKeep); // amountsLine is already up to date
        }
    }
    else if (detailsLine.title === "Marges sur production") {
        recomputeAmountsWhenMarginsChange(activity, amountsLine, amountChangedIndex, amountToKeep);
        recomputeSaisonnalityWhenAmountsChange(amountsLine, percentagesLine, amountChangedIndex, amountsLine.months[amountChangedIndex].amount);
    }
}

function recomputeAmountsWhenSaisonnalityChange(amountsLine, amountChangedIndex, percentageChanged) {
    amountsLine.months[amountChangedIndex].amount = (amountsLine.total * percentageChanged / 100).toFixed(0);
    if (!amountsLine.months[amountChangedIndex].edited) {
        amountsLine.uneditedCount -= 1;
        amountsLine.months[amountChangedIndex].edited = true;
    }
    const splittedAmount = (computeSubTotal(amountsLine) / amountsLine.uneditedCount).toFixed(0);
    for (let monthIndex = 0; monthIndex < 12; monthIndex++) {
        if(!amountsLine.months[monthIndex].edited) {
            amountsLine.months[monthIndex].amount = splittedAmount;
        }
    }
}

function recomputeAmountsWhenMarginsChange(activity, amountsLine, amountChangedIndex, amountChanged) {
    amountsLine.months[amountChangedIndex].amount = (100 * amountChanged / activity.marginRate).toFixed(2);
    if (!amountsLine.months[amountChangedIndex].edited) {
        amountsLine.uneditedCount -= 1;
        amountsLine.months[amountChangedIndex].edited = true;
    }
    const splittedAmount = (computeSubTotal(amountsLine) / amountsLine.uneditedCount).toFixed(0);
    for (let monthIndex = 0; monthIndex < 12; monthIndex++) {
        if(!amountsLine.months[monthIndex].edited) {
            amountsLine.months[monthIndex].amount = splittedAmount;
        }
    }
}

function recomputeSaisonnalityWhenAmountsChange(amountsLine, percentagesLine, amountChangedIndex, amountChanged) {
    percentagesLine.months[amountChangedIndex].amount = (100 * amountChanged / amountsLine.total).toFixed(2);
    if (!percentagesLine.months[amountChangedIndex].edited) {
        percentagesLine.uneditedCount -= 1;
        percentagesLine.months[amountChangedIndex].edited = true;
    }
    // const splittedAmount = (computeSubTotal(percentagesLine) / percentagesLine.uneditedCount).toFixed(2);
    // for (let monthIndex = 0; monthIndex < 12; monthIndex++) {
    //     if(!percentagesLine.months[monthIndex].edited) {
    //         percentagesLine.months[monthIndex].amount = splittedAmount;
    //     }
    // }
    for (let monthIndex = 0; monthIndex < percentagesLine.months.length; monthIndex++) {
        percentagesLine.months[monthIndex].amount = round(100 * amountsLine.months[monthIndex].amount / amountsLine.total, 2);
    }
}

function recomputeMargins(activity, marginsLine, amountChangedIndex, amountChanged) {
    marginsLine.months[amountChangedIndex].amount = (amountChanged * activity.marginRate / 100).toFixed(2);
    if(!marginsLine.months[amountChangedIndex].edited) {
        marginsLine.uneditedCount -= 1;
        marginsLine.months[amountChangedIndex].edited = true;
    }
    const splittedAmount = (computeSubTotal(marginsLine) / marginsLine.uneditedCount).toFixed(2);
    for (let monthIndex = 0; monthIndex < 12; monthIndex++) {
        if(!marginsLine.months[monthIndex].edited) {
            marginsLine.months[monthIndex].amount = splittedAmount;
        }
    }
}

function computeSubTotal(detailsLine) {
    // given a line, compute the total amount to be splitted between the unedited lines
    let subTotal = detailsLine.total;
    for (const month of detailsLine.months) {
        if (month.edited) {
            subTotal -= month.amount;
        }
    }
    return subTotal
}

export function buildChargeYearlyDetailsItems(charge, key, previousDetails, parameters, date_ = undefined) {
    // build or rebuild data structure every time the budget is loaded or a yearly total is modified
    const date = date_ || parameters.start
    if (key+1 > charge.years.length) {
        // years not used
        return [];
    }
    const yearlyDetailsItems = buildChargeYearlyDetailsItemsFromScratch(key, charge, parameters, date);
    if (!previousDetails || previousDetails.length === 0) {
        // first building at the creation of the budget, TO PUT IN CP ?
        return yearlyDetailsItems;
    }
    let oneEditedMonthIndex = -1; // counter keeping track of an edited month, used to update unmodified columns at the end (trick)
    for (let monthIndex = 0; monthIndex < previousDetails[0].months.length; monthIndex++) {
        // we could have taken yearlyDetailsItems to reference the indexes instead of previousDetails
        if (previousDetails[0].months[monthIndex].edited) {
            if (oneEditedMonthIndex < 0) {
                oneEditedMonthIndex = monthIndex;
            };
            if (previousDetails[0].months[monthIndex].manuallyModified) {
                // value to keep is the amount, computing the new saisonnalities and margins, but not updating the other columns yet to reduce computation time
                yearlyDetailsItems[0].uneditedCount -= 1;
                yearlyDetailsItems[0].months[monthIndex].edited = true;
                yearlyDetailsItems[0].months[monthIndex].manuallyModified = true;
                yearlyDetailsItems[0].months[monthIndex].amount = previousDetails[0].months[monthIndex].amount;
                yearlyDetailsItems[1].uneditedCount -= 1;
                yearlyDetailsItems[1].months[monthIndex].edited = true;
                yearlyDetailsItems[1].months[monthIndex].amount = (100 * yearlyDetailsItems[0].months[monthIndex].amount / yearlyDetailsItems[0].total).toFixed(2);
            }
            else if (previousDetails[1].months[monthIndex].manuallyModified) {
                // value to keep is the saisonnality, computing the new amounts and margins, but not updating the other columns yet to reduce computation time
                yearlyDetailsItems[1].uneditedCount -= 1;
                yearlyDetailsItems[1].months[monthIndex].edited = true;
                yearlyDetailsItems[1].months[monthIndex].manuallyModified = true;
                yearlyDetailsItems[1].months[monthIndex].amount = previousDetails[1].months[monthIndex].amount;
                yearlyDetailsItems[0].uneditedCount -= 1;
                yearlyDetailsItems[0].months[monthIndex].edited = true;
                yearlyDetailsItems[0].months[monthIndex].amount = (yearlyDetailsItems[0].total * yearlyDetailsItems[1].months[monthIndex].amount / 100).toFixed(0);
            }
        }
    }
    if (oneEditedMonthIndex >= 0) {
        recomputeWhenChange(null, yearlyDetailsItems, 0, oneEditedMonthIndex); // updating the unedited columns
    }
    return yearlyDetailsItems;
}

function buildChargeYearlyDetailsItemsFromScratch(key, charge, parameters, date) {
    // construction of the details at the creation of a budget, if there is no previous values
    const yearlyDetailsItems = [];
    const monthList = getOrderedMonthsPeriods(parameters, date)[key];
    const monthsNumber = monthList.length;
    const totalAmount = charge.years[key].amount;
    const splittedAmount = totalAmount / monthsNumber;
    const months = [];
    for (let monthIndex = 0; monthIndex < monthsNumber; monthIndex++) {
        const month = {
            amount: splittedAmount.toFixed(0),
            date: monthList[monthIndex],
            edited: false,
            manuallyModified: false
        };
        months.push(month)
    }
    const soldPrestations = {
        title: "Montant à payer",
        total: totalAmount,
        months: months,
        uneditedCount: months.length,
        editable: true
    };
    yearlyDetailsItems.push(soldPrestations);
    const monthsSaisonnality = []
    for (let monthIndex = 0; monthIndex < monthsNumber; monthIndex++) {
        const amount = totalAmount === 0 ? 0 : months[monthIndex].amount / totalAmount * 100
        const month = {
            amount: amount.toFixed(2),
            date: monthList[monthIndex],
            edited: false,
            manuallyModified: false
        };
        monthsSaisonnality.push(month);
    }
    const saisonnality = {
        title: "Saisonnalité",
        total: 100,
        months: monthsSaisonnality,
        uneditedCount: months.length,
        editable: true

    };
    yearlyDetailsItems.push(saisonnality);
    return yearlyDetailsItems;
}

export function buildStaffYearlyDetailsItems(staff, key, previousDetails, parameters, date_=null) {

    // build or rebuild data structure every time the budget is loaded or a yearly total from main component is modified
    let date
    if (!date_) {
        date = parameters.start
    } else {
        date = date_
    }
    if (key+1 > staff.years.length) {
        // years not used
        return [];
    }
    const yearlyDetailsItems = buildStaffYearlyDetailsItemsFromScratch(key, staff, parameters, date);
    if (!previousDetails || previousDetails.length === 0) {
        // first building at the creation of the budget, TO PUT IN CP ?
        return yearlyDetailsItems;
    }
    // for the workforce, instead of the yearly total, there is no need to rebuild the unedited columns at the end, they are already set to the correct value
    for (let monthIndex = 0; monthIndex < previousDetails[0].months.length; monthIndex++) {
        // we could have taken yearlyDetailsItems to reference the indexes instead of previousDetails
        if (previousDetails[0].months[monthIndex].edited) {
            // value to keep is the amount, computing the new saisonnalities, but not updating the other columns yet to reduce computation time
            markEditedValues(yearlyDetailsItems, monthIndex)
            yearlyDetailsItems[0].months[monthIndex].amount = previousDetails[0].months[monthIndex].amount;
            yearlyDetailsItems[2].months[monthIndex].amount = yearlyDetailsItems[0].months[monthIndex].amount * yearlyDetailsItems[1].months[monthIndex].amount;
        }
    }
    yearlyDetailsItems[0].total = averageYearlyWorkForce(yearlyDetailsItems[0].months);
    yearlyDetailsItems[2].total = computeLineSum(yearlyDetailsItems[2]);
    staff.years[key].totalAmount = yearlyDetailsItems[2].total;
    return yearlyDetailsItems;
}

function buildStaffYearlyDetailsItemsFromScratch(key, staff, parameters, date) {
    // construction of the details at the creation of a budget, if there is no previous values
    const yearlyDetailsItems = [];
    const monthList = getOrderedMonthsPeriods(parameters, date)[key];
    const monthsNumber = monthList.length;
    const numberToReplace = staff.number;
    const monthlyGrossSalary = round(staff.years[key].individualAmount / 12, 0);
    const monthsWorkForce = [];
    for (let monthIndex = 0; monthIndex < monthsNumber; monthIndex++) {
        const month = {
            amount: numberToReplace,
            date: monthList[monthIndex],
            edited: false,
            manuallyModified: false
        };
        monthsWorkForce.push(month)
    }
    const workForce = {
        title: "Effectif",
        total: averageYearlyWorkForce(monthsWorkForce),
        months: monthsWorkForce,
        uneditedCount: monthsWorkForce.length,
        editable: true
    };
    yearlyDetailsItems.push(workForce);
    const monthsGrossSalary = [];
    const yearlyGrossSalary = monthsNumber * monthlyGrossSalary;
    for (let monthIndex = 0; monthIndex < monthsNumber; monthIndex++) {
        const month = {
            amount: monthlyGrossSalary,
            date: monthList[monthIndex],
            edited: false,
            manuallyModified: false
        };
        monthsGrossSalary.push(month);
    }
    const monthlyGrossSalaries = {
        title: "Salaire mensuel individuel brut",
        total: yearlyGrossSalary,
        months: monthsGrossSalary,
        uneditedCount: monthsGrossSalary.length,
        editable: false
    };
    yearlyDetailsItems.push(monthlyGrossSalaries);
    const monthsGlobalGrossSalary = [];
    let yearlyGlobalGrossSalary = 0;
    for (let monthIndex = 0; monthIndex < monthsNumber; monthIndex++) {
        const monthlyGlobalGrossSalary = monthsWorkForce[monthIndex].amount * monthlyGrossSalary;
        yearlyGlobalGrossSalary += monthlyGlobalGrossSalary;
        const month = {
            amount: monthlyGlobalGrossSalary,
            date: monthList[monthIndex],
            edited: false,
            manuallyModified: false
        };
        monthsGlobalGrossSalary.push(month);
    }
    const monthlyGlobalGrossSalaries = {
        title: "Masse salariale mensuelle brut",
        total: yearlyGlobalGrossSalary,
        months: monthsGlobalGrossSalary,
        uneditedCount: monthsGlobalGrossSalary.length,
        editable: false
    };
    yearlyDetailsItems.push(monthlyGlobalGrossSalaries);
    return yearlyDetailsItems;
}

function averageYearlyWorkForce(months) {
    let average = 0;
    const length = months.length;
    for (const month of months) {
        average += month.amount;
    }
    average /= length;
    return round(average,1);
}

function computeLineSum(line) {
    let sum = 0;
    for (const month of line.months) {
        sum += month.amount;
    }
    return round(sum, 1);
}

function markEditedValues(yearlyDetails, monthIndex) {
    for (let lineIndex = 0; lineIndex < yearlyDetails.length; lineIndex++) {
        yearlyDetails[lineIndex].months[monthIndex].edited = true;
        yearlyDetails[lineIndex].months[monthIndex].manuallyModified = (lineIndex === 0);
        yearlyDetails[lineIndex].uneditedCount -= 1;
    }
}

function round(number, decimalNumber) {
    const factor = Math.pow(10, decimalNumber);
    return Math.round(number*factor)/factor;
}
